export default __webpack_public_path__ + "static/media/stack.d69ee020.jpg";